import "./SingleFlooringTemplate.module.css"
import WebsiteHeader from "@/reusable_sections/Header"
import SingleFlooringTemplateSection from "./sections/SingleFlooringTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleFlooringTemplatePage() {

  return (
    <div>
      <WebsiteHeader />
      <SingleFlooringTemplateSection />
      <Footer />
    </div>
  )
}
